<template>
    <div class="border-primary-400/20 bg-primary-900/30 overflow-hidden rounded border backdrop-blur-sm">
        <div :class="headerClasses" @click="toggle">
            <div class="flex min-w-0 flex-1 items-center gap-3">
                <p class="text-primary-50 truncate font-medium">
                    <t :path="name" />
                </p>
                <slot name="extra" />
            </div>

            <div class="flex items-center gap-2">
                <fa v-if="!alwaysOpen" :class="iconClasses" :icon="['fas', 'chevron-down']" />
            </div>
        </div>

        <Transition
            enter-active-class="transition-all duration-200 ease-out"
            enter-from-class="opacity-0 max-h-0"
            enter-to-class="opacity-100 max-h-96"
            leave-active-class="transition-all duration-150 ease-in"
            leave-from-class="opacity-100 max-h-96"
            leave-to-class="opacity-0 max-h-0"
        >
            <div v-if="toggled" class="overflow-hidden">
                <div class="border-primary-400/20 bg-primary-900/30 border-t px-3 py-2">
                    <slot />
                </div>
            </div>
        </Transition>
    </div>
</template>

<script lang="ts">
import { computed, defineComponent, ref } from 'vue';

export default defineComponent({
    props: {
        name: {
            type: [String, Array],
            required: true,
        },
        alwaysOpen: {
            type: Boolean,
            default: false,
        },
    },

    setup(props) {
        const toggled = ref(props.alwaysOpen ?? false);

        const headerClasses = computed(() => [
            'flex items-center justify-between px-3 py-2 transition-colors duration-200',
            {
                'cursor-pointer hover:bg-primary-500/60': !props.alwaysOpen,
                'bg-primary-900/30': props.alwaysOpen,
            },
        ]);

        const iconClasses = computed(() => [
            'text-primary-300 transition-transform duration-200 text-sm',
            {
                'rotate-180': toggled.value,
            },
        ]);

        const toggle = (value?: boolean | MouseEvent) => {
            if (props.alwaysOpen) return;

            if (typeof value === 'boolean') {
                toggled.value = value;
            } else {
                toggled.value = !toggled.value;
            }
        };

        return {
            toggled,
            toggle,
            headerClasses,
            iconClasses,
        };
    },
});
</script>
